import React from 'react'
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'

const Loading = () => {
  return (
    <div
      style={{
        zIndex: 100000,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <Backdrop open>
        <CircularProgress color='inherit' />
      </Backdrop>
    </div>
  )
}

export default Loading
